import React, { useEffect, useState, useRef } from "react";
import {
  bp_add_meta_data,
  bp_get_machine_by_machine_typ,
  bp_machine_data,
  bp_save_batch_parameters,
} from "../../../utils/api";
import { toast } from "react-toastify";
import { Form, Input, Select, Button, Descriptions, Avatar } from "antd";
import MainCard from '@/components/MainCard';
import { useDispatch, useSelector } from "react-redux";
import { settab_number } from '@/store/reducers/tabNumber';
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';

function AddData() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const operation_data = state?.operation_data;
  const dispatch = useDispatch();
  const [machine, set_machine] = useState("");
  const [param_value, set_param_value] = useState("");
  const [remark, set_remark] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    submit_function();
  };

  //####################### Handle Api's######################################################

  const [machine_data, setMachineData] = useState([]);
  const get_all_machine = async () => {
    try {
      await bp_get_machine_by_machine_typ(success_machine_list_get, {
        machine_type_id: operation_data?.machine_id,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_machine_list_get = (res) => {
    setMachineData(res?.data?.data);
  };

  useEffect(() => {
    get_all_machine();
  }, [operation_data]);

  const submit_function = async (metaData) => {
    try {
      await bp_save_batch_parameters(
        {
          process_parameter: param_value?.filter(Boolean),
          operation_id: operation_data?.operation_id,
          machine_id: machine,
          batch_number: operation_data?.batch_number,
        },
        success_bp_save_batch_parameters
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_bp_save_batch_parameters = (res) => {
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      navigate("/batch");
      resetFunction();
      toast.success("Parameter value added successfully");
    }
  };

  const resetFunction = () => {
    set_param_value([]);
    set_remark("");
    set_machine("");
  };

  const handle_parameter = (ingredient_id, e, index) => {
    if (e.target.value === "") {
      let temp = [...param_value];
      temp.splice(index, 1);
      set_param_value(temp);
    } else {
      let temp = [...param_value];
      temp[index] = {
        process_parameter_id: ingredient_id,
        value: e.target.value,
      };
      set_param_value(temp);
    }
  };

  return (
    <MainCard darkTitle title="Parameters" backbutton>
      <form onSubmit={handleSubmit}>
        <Descriptions
          title=""
          bordered
          column={2}
          contentStyle={{
            fontSize: "24px",
          }}
          labelStyle={{
            fontSize: "32px",
            fontWeight: "bold",
          }}
          items={[
            {
              key: "5",
              label: "Instruction",
              children: operation_data?.instruction,
              span: 2,
            },
            {
              key: "1",
              label: "Batch No",
              children: operation_data?.batch_number,
            },
            {
              key: "2",
              label: "Operation",
              children: `${operation_data?.operation_type} - ${operation_data?.operation_number}`,
            },
            {
              key: "3",
              label: "Machine",
              children: (
                <Select
                  value={machine}
                  size="large"
                  placeholder="Select Machine"
                  onChange={(value) => set_machine(value)}
                  style={{
                    width: "100%",
                    fontSize: "24px",
                  }}
                  options={machine_data?.map((item) => ({
                    label: item.machine_name,
                    value: item.machine_id,
                  }))}
                />
              ),
            },
            {
              key: "4",
              label: "Duration",
              children: operation_data?.max_duration,
            },
          ]}
        />

        <div className="my-8 space-y-6">
          {operation_data?.paramaters?.map((item, index) => (
            <div key={index} className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-center">
              <div className="lg:col-span-4">
                <label className="text-2xl font-medium text-center block">
                  {item?.parameter_name}
                </label>
              </div>
              <div className="lg:col-span-8">
                <Input
                  type="number"
                  size="large"
                  value={param_value[index]?.value}
                  onChange={(e) => {
                    handle_parameter(item?.parameter_id, e, index);
                  }}
                  suffix={
                    <Avatar
                      shape="square"
                      style={{
                        color: "#000",
                        backgroundColor: "#fff",
                        fontSize: "24px",
                      }}
                    >
                      {`${item?.parameter_name
                        ?.split(" ")
                        .pop()
                        .replace(")", "")}`}
                    </Avatar>
                  }
                  style={{
                    height: "50px",
                    fontSize: "24px",
                  }}
                />
              </div>
            </div>
          ))}

          <div className="flex justify-end items-end gap-2 mt-6">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{
                backgroundColor: defaultColors.primary,
                borderColor: defaultColors.primary,
                height: "50px",
                fontSize: "24px",
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </form>
    </MainCard>
  );
}

export default AddData;
